// import { DialogType } from "@/components/Dialogs/types";
// import { useDialog } from "@/components/Dialogs/useDialog";
import { FrontCfgEnum } from "@/enum/front";
import { hideLoading, showLoading } from "@/hooks/useLoading.tsx";
import { toOutLink } from "@/lib/utils.ts";
import { isVivai, openChart } from "@/lib/vivai";
import { configStore } from "@/stores/configStore";
import { userStore } from "@/stores/userStore";

export function useLiveChat() {
  let liveChatStatus = 0; // 0 = 未加载, 1 = 加载中, 2 = 完成
  let initLiveChatCount = 0;

  const loadLiveChat = (liveChatId: string) => {
    if (!liveChatId) return;
    liveChatStatus = 1;
    initLiveChatCount = 0;
    showLoading();

    const script = document.createElement("script");
    script.innerHTML = `
		window.__lc = window.__lc || {};
		window.__lc.license = ${liveChatId};
		(function(n,t,c){
			function i(n){ return e._h ? e._h.apply(null,n) : e._q.push(n); }
			var e = {
				_q: [], _h: null, _v:"2.0",
				on: function(){ i(["on", c.call(arguments)]) },
				once: function(){ i(["once", c.call(arguments)]) },
				off: function(){ i(["off", c.call(arguments)]) },
				get: function(){
					if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
					return i(["get", c.call(arguments)])
				},
				call: function(){ i(["call", c.call(arguments)]) },
				init: function(){
					var n = t.createElement("script");
					n.async = true; n.type = "text/javascript";
					n.src = "https://cdn.livechatinc.com/tracking.js";
					t.head.appendChild(n);
				}
			};
			!n.__lc.asyncInit && e.init();
			n.LiveChatWidget = n.LiveChatWidget || e;
		})(window, document, [].slice);
	`;
    // console.log(document?.body);
    document?.body?.appendChild(script);

    // 添加 noscript
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
		<a href="https://www.livechat.com/chat-with/${liveChatId}/" rel="nofollow">Chat with us</a>,
		powered by <a href="https://www.livechat.com/?welcome" rel="noopener nofollow" target="_blank">LiveChat</a>
	`;
    document?.body?.appendChild(noscript);

    initLiveChat();
  };

  const initLiveChat = () => {
    setTimeout(() => {
      if (window.LiveChatWidget) {
        // console.log("LiveChatWidget register suc");
        window.LiveChatWidget.on("ready", LiveChatOnReady);
        window.LiveChatWidget.on(
          "customer_status_changed",
          LiveChatOnCustomerStatusChanged,
        );
      } else if (initLiveChatCount < 20) {
        initLiveChatCount++;
        initLiveChat();
      } else {
        console.error("LiveChatWidget register failed");
        liveChatStatus = 0;
        initLiveChatEnd();
      }
    }, 1000);
  };

  const initLiveChatEnd = () => {
    // 关闭loading
    hideLoading();
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const LiveChatOnCustomerStatusChanged = (data: any) => {
    // console.log("LiveChatWidget LiveChatState:" + JSON.stringify(data));
    // switch (data.status) {
    //     case "queued":
    //     // customer is in queue
    //     break;
    //     case "chatting":
    //     // customer is currently chatting
    //     break;
    //     case "invited":
    //     // customer received an invitation but didn't start the chat
    //     break;
    //     case "browsing":
    //     // customer is in idle state, not queued, not chatting, and didn't receive an invitation
    //     break;
    // }
    if (data.status == "chatting") {
      if (userStore.isLogin) {
        const uid = userStore.userInfo?.uid;
        const customerData = window.LiveChatWidget.get("customer_data");
        // console.log(
        //   "LiveChatWidget LiveChatUserData: " + JSON.stringify(customerData),
        // );
        let oldName = customerData.name || "";
        const match = /\[[0-9]+\]/gi.exec(oldName);
        if (match?.[0]) {
          oldName = oldName.replace(match[0], "");
          console.error("LiveChatWidget value: " + match[0]);
        }
        const newName = oldName + `[${uid}]`;
        window.LiveChatWidget.call("set_customer_name", newName);
        // console.log("LiveChatWidget LiveChatSetNewName:" + newName);
      }
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const LiveChatOnReady = (initialData: any) => {
    // console.log(
    //   "LiveChatWidget LiveChatOnReady: " + JSON.stringify(initialData),
    // );
    liveChatStatus = 2;
    initLiveChatEnd();
    setTimeout(() => {
      clickLiveChat();
    }, 300);
  };

  const getLiveChatCfg = () => {
    const cfg = configStore.frontCfgMap[FrontCfgEnum.LiveChatConfig];
    if (cfg) {
      return cfg;
    }
    return null;
  };

  const clickLiveChat = () => {
    if (isVivai) {
      openChart();
      return false;
    }
    const liveChatCfgFromSvr = getLiveChatCfg()?.live_chat_config;
    const chatId = getLiveChatCfg()?.live_chat_id;

    let liveChatCfg = null;
    if (liveChatCfgFromSvr) {
      liveChatCfg = JSON.parse(JSON.stringify(liveChatCfgFromSvr));
      const liveChatList = Object.entries(liveChatCfg);
      if (
        liveChatList.some((el: object) => el[1] && typeof el[1] == "object")
      ) {
        const realMaps: object = {};
        liveChatList.forEach((item: object) => {
          const ids = item[0].split("_").map((temp: string) => Number(temp));
          for (let i = ids[0]; i <= ids[1]; i++) {
            realMaps["vip_" + i] = item[1].url;
          }
        });
        liveChatCfg = realMaps;
      }
    }
    const userVipLevel = userStore.userInfo?.UserVip?.vip_level ?? 0;
    let curLiveChatId = "";
    if (liveChatCfg && userVipLevel) {
      for (let vipLevel = userVipLevel; vipLevel >= 0; vipLevel--) {
        curLiveChatId = liveChatCfg["vip_" + vipLevel];
        if (curLiveChatId) {
          break;
        }
      }
    }
    if (!curLiveChatId && chatId) {
      curLiveChatId = chatId;
    }

    // if (!curLiveChatId) {
    //   const { showDialog } = useDialog();

    //   showDialog({ type: DialogType.Salesforce });
    //   return;
    // }

    if (curLiveChatId.startsWith("http")) {
      toOutLink(curLiveChatId);
      return;
    }

    if (window.LiveChatWidget && liveChatStatus === 2) {
      window.LiveChatWidget.call("maximize");
    } else if (liveChatStatus === 0) {
      loadLiveChat(curLiveChatId);
    }
  };

  return {
    loadLiveChat,
    clickLiveChat,
  };
}
